import React, { useState } from 'react'
import { IconButton, Menu, MenuItem, ListItemIcon, ListItemText, Typography } from '@mui/material'
import MoreVert from '@mui/icons-material/MoreVert'

export default function ThreeDotsMenu({
  menuItems = [],
  size = 'small',
  iconColor = 'inherit',
  disabled = false,
}) {
  const [anchorEl, setAnchorEl] = useState(null)
  const open = Boolean(anchorEl)

  const handleClick = (event) => {
    event.stopPropagation()
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  const handleMenuItemClick = (item) => {
    handleClose()
    if (item.onClick) {
      item.onClick()
    }
  }

  return (
    <>
      <IconButton
        size={size}
        onClick={handleClick}
        disabled={disabled}
        sx={{
          color: iconColor,
          '&:hover': {
            backgroundColor: 'rgba(0, 0, 0, 0.04)',
          },
        }}
      >
        <MoreVert />
      </IconButton>

      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        {menuItems.map((item, index) => (
          <MenuItem key={index} onClick={() => handleMenuItemClick(item)} disabled={item.disabled}>
            <ListItemIcon>{item.icon && <item.icon {...item.iconProps} />}</ListItemIcon>
            <ListItemText>{item.label}</ListItemText>
            {item?.secondaryLabel && (
              <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                {item?.secondaryLabel}
              </Typography>
            )}
          </MenuItem>
        ))}
      </Menu>
    </>
  )
}
